import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteWatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        return platformApi.delete(`watches/${code}`);
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['watches'] }),
  });
}
